/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {RecentReport, Report} from '../model/report';

@Injectable()
export class RecentReportService {
  private MAX_HISTORY = 10;

  recentReports = new BehaviorSubject<RecentReport[]>([]);
  recentReports$ = this.recentReports.asObservable();

  constructor() {}

  addToHistory(report: Report): void {
    if (this.recentReports.getValue().length > 0) { // if there is any reports in stack
      // If Latest report in stack is not current report
      if (this.recentReports.getValue()[0].ID !== report.ID) {
        for (let i = 0; i < this.recentReports.getValue().length; i++) {
          // Remove Report from stack
          if (this.recentReports.getValue()[i].ID === report.ID)
            this.recentReports.getValue().splice(i, 1);
        }

        // Add Report to top of stack
        this.recentReports.getValue().unshift(new RecentReport(report));

        // If stack is more than MAX_HISTORY, slice it
        if (this.recentReports.getValue().length > this.MAX_HISTORY)
          this.recentReports.next(this.recentReports.getValue().slice(0, this.MAX_HISTORY - 1));

      } // if latest, ignore
    } else this.recentReports.getValue().unshift(new RecentReport(report));
  }
}
